import { ItemInfoButton } from '@bonanza-social/moonlight';
import { BottomSheet } from '@bonanza-social/navigation';
import { memo, useCallback } from 'react';
import { ShopItemType } from '../../state/items/items.types';
import { ShopSlotItemType } from '../../state/slots/slots.types';

function ShopItemInfo(item: ShopItemType | ShopSlotItemType) {
  const { name, description, type, mysteryBoxConfiguration } = item;

  const onInfo = useCallback(
    () =>
      type === 'MysteryBox' && mysteryBoxConfiguration?.itemDrops
        ? BottomSheet.open({
          title: name,
          namespace: 'shop',
          type: 'MysteryBoxInfo',
          data: {
            description,
            itemDrops: mysteryBoxConfiguration.itemDrops,
          },
        })
        : BottomSheet.open({
          namespace: 'shop',
          type: 'ShopItemInfo',
          title: name,
          data: {
            text: description,
          },
        }),
    [name, description, type, mysteryBoxConfiguration],
  );

  return (
    <ItemInfoButton
      onInfo={onInfo}
      position="absolute"
      zIndex={10}
      top="space-200"
      right="space-200"
    />
  );
}

export default memo(ShopItemInfo);
